module.exports = __webpack_public_path__ + "img/box_pro_three_3.9557677a.jpg";